module.exports = __webpack_public_path__ + "img/check.e2d308a4.svg";